import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { TransferSearchFormValues } from "./schema";

export interface TransferListQuery {
  readonly status: TransferSearchFormValues["status"];
  readonly accountNumber?: string;
  readonly purpose: TransferSearchFormValues["purpose"];
  readonly keyword: string;
  readonly memberId?: number;
  readonly from: string;
  readonly to: string;
  readonly page: number;
  readonly size: number;
}

export async function getTransfers(
  apiClient: ApiClient,
  query: TransferListQuery,
  signal?: AbortSignal,
): Promise<Schemas["AdminBoPageTransferAdminView"]> {
  const response = await apiClient.get<Schemas["AdminBoPageTransferAdminView"]>(
    "/api/v1/admin/bo/transfers",
    {
      query: {
        status: query.status || undefined,
        accountNumber: query.accountNumber?.replace(/[^0-9]/g, "") || undefined,
        keyword: query.keyword || undefined,
        from: query.from || undefined,
        to: query.to || undefined,
        page: query.page,
        size: query.size,
      },
      signal,
    },
  );
  return response.data;
}

export async function getTransferDetail(
  apiClient: ApiClient,
  transferId: number,
  signal?: AbortSignal,
): Promise<Schemas["TransferAdminView"]> {
  const response = await apiClient.get<Schemas["TransferAdminView"]>(
    `/api/v1/admin/transfers/${transferId}`,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function executeTransfer(
  apiClient: ApiClient,
  transferId: number,
  signal?: AbortSignal,
): Promise<Schemas["TransactionView"]> {
  const response = await apiClient.post<Schemas["TransactionView"]>(
    `/api/v1/admin/transfers/${transferId}/execute`,
    undefined,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function cancelTransfer(apiClient: ApiClient, transferId: number, reason: string, idempotencyKey: string): Promise<Schemas["TransferAdminView"]> {
  return (await apiClient.post<Schemas["TransferAdminView"]>(`/api/v1/admin/transfers/${transferId}/cancel`, {reason}, {headers:{"Idempotency-Key":idempotencyKey},cache:"no-store"})).data;
}
